import { render, staticRenderFns } from "./donor-profile.vue?vue&type=template&id=50fc8666&"
import script from "./donor-profile.vue?vue&type=script&lang=js&"
export * from "./donor-profile.vue?vue&type=script&lang=js&"
import style0 from "./donor-profile.vue?vue&type=style&index=0&id=50fc8666&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports